
<template>
  <v-app id="onVtwd">
    <v-main>
      <v-container fluid>  
        <v-card flat>
          <v-card-title>            
            <div style="display: flex; flex-direction: row; align-items: center;">Code: {{vtwd.vtwd_code}} -- {{vtwd.vtwd_oms}}<v-btn small color="primary" @click="saveAll" class="ml-4">Save All</v-btn></div>
          </v-card-title>
          <div v-for="(vrtlRecord,i) in vtwd.vrtl" :key="i" class="px-4">
            <div style="display: flex; flex-direction: row; align-items: center; margin-bottom: 15px; margin-top: 10px;">
                <div style="font-weight: bold; font-size: x-large">{{vrtlRecord.taal_code}}</div>
                <v-btn class="primary ml-4" small @click="saveVrtl(vrtlRecord)">Save</v-btn>
            </div>
            <v-textarea v-model="vrtlRecord.vrtl_vertaling" :value=vrtlRecord.vrtl_vertaling rows="1" label="Translation"></v-textarea>
          </div>  
        </v-card>  
      </v-container>
    </v-main>
    <navBar title="Ares - Reference data" :home="true" type="referencedata"/>
  </v-app>
</template>


<script>
import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar
  },
  props: ['vtwd_encrid'],
  data() {
    return {
      vtwd: {}
    }  
  },
  mounted() {
      this.$axios
        .post("ares/json/ares/syst/ref/vtwd/getVtwd.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getVtwd"
          },
          getVtwd: {
             vtwd_encrid: this.vtwd_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.vtwd = res.data.getVtwd;
            document.title = "ARES - Word (" + this.vtwd.vtwd_code  + ")"
          }
        })
        .finally(() => {
          this.loading = false;
        });        
    },
  methods: {
    saveVrtl(vrtl) { 
      console.log(vrtl.taal_code, vrtl.vrtl_vertaling)
      this.$axios
        .post("ares/json/ares/syst/ref/vtwd/saveVrtl.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "saveVrtl"
          },
          saveVrtl: {
            vrtl: vrtl
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else {
            this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.saveVrtl.text,
              color: res.data.saveVrtl.color
            });
          }
        })
    },
    saveAll(){
      this.vtwd.vrtl.forEach(element => {
        this.saveVrtl(element)
      });
    }

  }  

};

</script> 

